const parseStringToFloat = (stringNumber: string): number =>
  parseFloat(stringNumber.replace(',', '.'));

export default parseStringToFloat;
